import { billing } from '@/services/billing';
import { createPersistedSnackbar, snackbarApi } from '@/services/snackbar';

const SUCCESS_MESSAGE = 'You have been moved to the Builder plan.';
const ERROR_MESSAGE = "Your account couldn't be moved to the Builder plan. Contact win@customer.io for help.";

/**
 * Applies the downgrade and tells the user the result. The billing task makes the change only, so the
 * messages belong here, where both callers share them.
 *
 * It rejects after a failure, because the confirm step reads a rejection as "keep the modal open".
 */
export async function applyBuilderDowngrade(leaveThePage: () => void): Promise<void> {
  try {
    await billing.downgradeToBuilder.perform();
  } catch (error) {
    snackbarApi.create({
      id: 'account.billing.builder-downgrade.error',
      variant: 'critical',
      message: ERROR_MESSAGE,
    });
    throw error;
  }

  // Keep the default timeout. A permanent message continues after the reload, and the user must then
  // close it.
  createPersistedSnackbar({
    id: 'account.billing.builder-downgrade.success',
    variant: 'default',
    message: SUCCESS_MESSAGE,
  });

  leaveThePage();
}
